import { uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';

export const getUiBlockerStyles = (_components, { palette }) => ({
  '@global': {
    ...uiblockerStyle({ palette }),
  },
});
